import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, faUsers, faHardHat, faIdCard, faClock, faBook, 
  faClipboardList, faMoneyCheckAlt, faMoneyBillWave, faHandsHelping, 
  faImage, faEye, faStar, faQrcode, faUser, faLockOpen,
  faSadCry,
  faWallet,
  faSearch, faClipboardQuestion, faClockRotateLeft
} from '@fortawesome/free-solid-svg-icons';
import './JobsWorks.css';
// import bluehandsimage from '../../assets/gdashboard/BlueHands.webp';

function SportsJobsHome() {
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [searchQuery, setSearchQuery] = useState("");
  const [category, setCategory] = useState("Labour");
  const [searchCity, setSearchCity] = useState("Mumbai");
  const [searchGender, setSearchGender] = useState("Male");

  const handleSearch = () => {
    // console.log("Search Query:", searchQuery);
    // console.log("Category:", category);
    // console.log("City:", city);
    // API Call for database fetching logic here
  };


  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 mt-12">
        <h2 className='text-3xl font-bold text-white text-center mb-6'>SportsJobs</h2>
        <div className="min-h-[100vh] px-4">
          <div className="flex flex-col items-center mb-8 mt-16 border-2 border-yellow-200 rounded-md p-6">
            <div className="flex flex-row justify-center md:flex-row md:space-x-4 space-y-4 md:space-y-0 w-full">
              <label>
                <FontAwesomeIcon icon={faSearch} className='text-yellow-200 text-lg ml-4'/>
              </label>
              <input
                type="text"
                placeholder="Enter search keywords eg Batsman, Goalkeeper etc"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
              >
                <optgroup label="Coaching">
                  <option value="Head Coach">Head Coach</option>
                  <option value="Assistant Coach">Assistant Coach</option>
                  <option value="Specialized Coach">Specialized Coach</option>
                </optgroup>
                <optgroup label="Officiating">
                  <option value="Referee">Referee</option>
                  <option value="Umpire">Umpire</option>
                  <option value="Linesman">Linesman</option>
                  <option value="Scorer">Scorer</option>
                  <option value="Match Commissioner">Match Commissioner</option>
                </optgroup>
                <optgroup label="Players">
                    <option value="U-12">U-12</option>
                    <option value="U-15">U-15</option>   
                    <option value="U-17">U-17</option>   
                    <option value="U-19">U-19</option>    
                    <option value="U-21">U-21</option>   
                    <option value="Open">Open</option>   
                    <option value="40+">40+</option>   
                    <option value="Veteran Players">Veteran</option>
                </optgroup>
                <optgroup label="Scout">
                  <option value="Baseball Scout">Baseball Scout</option>
                  <option value="Basketball Scout">Basketball Scout</option>
                  <option value="Boxing Scout">Boxing Scout</option>
                  <option value="Cricket Scout">Cricket Scout</option>
                  <option value="Esports Scout">Esports Scout</option>
                  <option value="Field Hockey Scout">Field Hockey Scout</option>
                  <option value="Football Scout">Football Scout</option>
                  <option value="Golf Scout">Golf Scout</option>
                  <option value="Gymnastics Scout">Gymnastics Scout</option>
                  <option value="Motorsport Scout">Motorsport Scout</option>
                  <option value="Rugby Scout">Rugby Scout</option>
                  <option value="Swimming Scout">Swimming Scout</option>
                  <option value="Tennis Scout">Tennis Scout</option>
                  <option value="Track and Field Scout">Track and Field Scout</option>
                  <option value="Volleyball Scout">Volleyball Scout</option>
                  <option value="Others Scout">Others Scout</option>
              </optgroup>
                <optgroup label="Trainers">
                  <option value="Physical Trainer">Physical Trainer</option>
                  <option value="Fitness Coach">Fitness Coach</option>
                  <option value="Sports Nutritionist">Sports Nutritionist</option>
                  <option value="Performance Analyst">Performance Analyst</option>
                </optgroup>
                <optgroup label="Medical Team">
                  <option value="Sports Doctor">Sports Doctor</option>
                  <option value="Physiotherapist">Physiotherapist</option>
                  <option value="Sports Psychologist">Sports Psychologist</option>
                  <option value="Massage Therapist">Massage Therapist</option>
                </optgroup>
                <optgroup label="Administrating">
                  <option value="Team Manager">Team Manager</option>
                  <option value="Event Coordinator">Event Coordinator</option>
                  <option value="Logistics Officer">Logistics Officer</option>
                  <option value="Sponsorship Manager">Sponsorship Manager</option>
                </optgroup>
              </select>
              <select
                value={searchCity}
                onChange={(e) => setSearchCity(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-3 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
                >
                <option value="Any Location">Any Location</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Delhi">Delhi</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Ahmedabad">Ahmedabad</option>
                <option value="Hyderabad">Hyderabad</option>
                <option value="Chennai">Chennai</option>
                <option value="Pune">Pune</option>
              </select>
              <select
                value={searchGender}
                onChange={(e) => setSearchGender(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-3 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
                >
                <option value="Men">Men</option>
                <option value="Women">Women</option>
                <option value="Any Gender">Any Gender</option>
              </select>
            </div>
            <div>
              <button
                onClick={handleSearch}
                className="bg-blue-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Search
              </button>
              <button
                onClick={handleSearch}
                className="bg-blue-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Instant
              </button>
            </div>
          </div>


          <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-250">
            <CardLink to="/sportsjob-iamavailable" icon={faHandsHelping} text="I am Available" />
            <CardLink to="/myprofile-sportsjobprofile" icon={faUser} text="My Sports Profile" />
            <CardLink to="/contact-genious-myqr" icon={faQrcode} text="My QR Code" />
            <CardLink to="/contact-genious/sports" icon={faIdCard} text="My Secure Digital Card" />
            <CardLink to={`/pub/sports/${userCode}`} icon={faLockOpen} text="My Public Digital Card" />
            <CardLink to="/chronocheck-home" icon={faClock} text="My Attendance" />
            <CardNoLink to="" icon={faBook} text="My Work Diary" />
            <CardNoLink to="" icon={faUser} text="Write My Bio-Data" />
            <CardNoLink to="" icon={faMoneyBillWave} text="Payments" />
            {/* <CardLink to="/contact-genious-change-profile-image" icon={faImage} text="Profile Image" /> */}
            <CardNoLink to="" icon={faClipboardQuestion} text="My Shortlisted Jobs" />
            <CardNoLink to="" icon={faClockRotateLeft} text="Jobs I Applied" />
            <CardNoLink to="" icon={faSadCry} text="Today I Was Jobless" />
            <CardNoLink to="" icon={faQrcode} text="My Search Log" />
            <CardNoLink to="" icon={faEye} text="Who Searched Me" />
            <CardNoLink to="" icon={faWallet} text="Price List" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default SportsJobsHome;


